import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import './assets/css/custom/general_system_management.css'
import App from './App'
import registerPlugins from './plugins'

import { platform, isMerchant, isAdmin, isProd } from './env'
import { notification } from 'ant-design-vue'
import { composeCommonExt } from '@activity/api/iht.js'
import { Modal, message } from '@activity/utils/modal-message.js'

import { mapGetters } from 'vuex'
import { GTMHookItem } from '@activity/utils/actGTM'
import { initAdminAnalytics } from '@klook/admin-analytics'
import '@klook/admin-ui/lib/index.css'

import { initAuthDirective, setDisabledLoop, setMutationObserver } from './plugins/authDirective'
import { handleIHTrack } from '@activity/utils/inHouseTrack.js'

import sentry from '@activity/utils/sentry'

Vue.config.productionTip = false

if (isProd) {
  initAdminAnalytics({ Vue })
}

Vue.prototype.GTMHookItem = GTMHookItem
Vue.prototype.$modal = Modal
Vue.prototype.$message = message
Vue.prototype.$notification = notification
Vue.prototype.$composeCommonExt = composeCommonExt

const admin_const = require('@/admin_const')
const context = {
  isMerchant
}

// expose edit_lang from here
typeof window.klk_gvars === 'object' || (window.klk_gvars = {})
klk_gvars.edit_lang = []
klk_gvars.position = []

async function createApplication() {
  registerPlugins(context).then(() => {
    initAuthDirective()
    sentry(context)
    // 替换ant-design-vue组件为自定义组件
    import('./plugins/overrideAntdComp')
      .then(({ default: overrideAntdComp }) => {
        overrideAntdComp()
        createApp()
      })
      .catch(() => {
        createApp()
      })
  })
}

const editRoutes = ['/act/activity/', '/act/package/']
function createApp() {
  const { i18n, router, isMerchant, antLocale = {} } = context
  const app = new Vue({
    el: '#app',
    router,
    i18n,
    render: function (h) {
      if (isMerchant) {
        return (
          <a-config-provider locale={antLocale}>
            <App />
          </a-config-provider>
        )
      }
      return <App />
    },
    data() {
      return {
        platform,
        isMerchant,
        isAdmin,
        nonEdit2act: false, //全局锁，这里的实现如果改了，请改一下另一个地方（搜索editInventory）
        nonEdit2status: false, //状态锁，这里的实现如果改了，请改一下另一个地方（搜索editInventory）
        template_id: 0,
        isNewFlowFlag: false,
        gsaveBtnDisabled: false,
        roles: {
          is_am: false,
          is_em: false,
          is_view_admin: false
        }
      }
    },
    methods: {
      ...mapGetters(['getCategoryInfo2getters']),
      bindIHTrack(...args) {
        return handleIHTrack(...args)
      },
      async trackIHEvent(el, extOpt = {}, otherOption = {}) {
        let dom = document.querySelector(el)
        if (!dom) {
          return
        }
        await this.$tracker.updateBinding(dom, { ext: extOpt, ...otherOption })
        this.$nextTick(() => {
          this.$tracker.track('action', dom)
          dom = null
        })
      },
      setMutationObserver(el, vm, cb) {
        setMutationObserver(el, () => {
          // this.setDisabled2calss(el)

          this.setDisabledLoop(vm || this, cb)
        })
      },
      setDisabled2calss: _.debounce(function (el) {
        const disabeldClass = 'common-disabled-style-global'
        let node = document.querySelector(el)
        let claArr = node.className.split(/\s+/)
        let hasDisabled = claArr.some((cls) => cls === disabeldClass)
        if (!hasDisabled) {
          claArr.push(disabeldClass)
          node.className = claArr.join(' ')
        }
      }, 300),
      setDisabledLoop: _.debounce(function (vm, cb) {
        // temp hack
        // eslint-disable-next-line
        let isStatusLock =
          this.nonEdit2status && editRoutes.some((path) => this.$route.path.indexOf(path) !== -1)
        let noLock = !this.nonEdit2act && !isStatusLock
        let customLock = false
        if (typeof cb === 'function') {
          customLock = !!cb({
            isLock: !noLock
          })
        }
        if (!customLock) {
          if (noLock && !customLock) return
        }
        let arr = [
          'AInput',
          'ASelect',
          'Input',
          'Select',
          'ACheckboxGroup',
          'ACheckbox',
          'Checkbox',
          'ARadioGroup',
          'ARadio',
          'ATextarea',
          'AButton',
          'SimpleMde',
          'ACascader'
        ]
        arr.forEach((key) => {
          setDisabledLoop.call(vm, key, {
            $props: {
              disabled: true
            }
          })
        })
      }, 300)
    },
    computed: {
      isToursMultiPath() {
        return location?.pathname?.includes?.('/aid/tours-multi/')
      },
      superEditLock() {
        return this.nonEdit2act || this.nonEdit2status
      }, //超级锁
      isWifiSim() {
        return [7, 8].includes(this.template_id)
      },
      isFNB() {
        return this.template_id == 4
      },
      isSIM() {
        return this.template_id === 8
      },
      isSPU() {
        return admin_const.spu_template_ids.includes(this.template_id)
      },
      isYSIM() {
        return this.template_id === 9
      },
      isHotel() {
        return this.template_id === 14
      },
      onlyEMPermission() {
        const { is_am, is_em } = this.roles

        return !is_am && is_em
      }
    }
  })

  return app
}

createApplication()
